import React from 'react'

import { StepsPaginator } from 'partials/StepsPaginator'

import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

type Props = {
  currentStep: number
  totalSteps: number
}

export const OnBoardingHeader = ({ currentStep, totalSteps }: Props) => {
  return (
    <Box>
      <Box align='center' justifyContent='center'>
        <Text fontSize='md' color='white' bold>
          {`${currentStep}/${totalSteps}`}
        </Text>
      </Box>
      <Box height={28} justifyContent='center'>
        <StepsPaginator currentStep={currentStep} totalSteps={totalSteps} />
      </Box>
    </Box>
  )
}
